import React, { useState } from 'react';
import * as Yup from 'yup';
import { Field, Form, getIn, withFormik } from 'formik';
import { Button, Col, Row } from 'react-bootstrap';
import FormikSelectClear from '../../../components/Utils/Select/FormikSelectClear';

const VacationBalance = ({
  employees,
  setFieldValue,
  errors,
  touched,
  successFetchEmployee,
  isArial,
  isSubmitting,
  onSelectEmployee
}) => {
  const [selectedEmployeeLocal, setSelectedEmployeeLocal] = useState(null);
  const employeePlaceholder = successFetchEmployee ? 'Seleccione colaboradores' : 'Cargando colaboradores...';
  const filteredEmployees = employees.filter(emp => emp.value !== '');
  const employeesOptions = filteredEmployees.length > 0 ? filteredEmployees : employees;

  const handleSelectEmployee = () => {
    const id =
      selectedEmployeeLocal && (selectedEmployeeLocal.id || selectedEmployeeLocal.value)
        ? selectedEmployeeLocal.id || selectedEmployeeLocal.value
        : null;
    if (typeof onSelectEmployee === 'function') {
      onSelectEmployee(id);
    }
  };

  return (
    <Form className="reports_filter__overflow">
      <Row>
        <Col sm={12} md={5} xs={12}>
          <Field name="employees">
            {({ field }) => (
              <FormikSelectClear
                {...field}
                abbr
                label="Nombres y Apellidos"
                options={employeesOptions}
                placeholder={employeePlaceholder}
                onChange={data => {
                  setFieldValue(field.name, data || null);
                  setSelectedEmployeeLocal(data || null);
                }}
                isClearable
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col md={2} className="mt-4">
          <Button
            className={`btn-block ellipsis ${isArial ? 'arial-dt' : ''}`}
            disabled={!successFetchEmployee || isSubmitting}
            type="button"
            onClick={() => {
              handleSelectEmployee();
            }}
          >
            Filtrar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

const validationSchema = Yup.object().shape({
  employees: Yup.mixed().test('required-employee', 'Debes seleccionar un trabajador', value => {
    if (!value) return false;
    return !!(value && (value.id || value.value));
  }),
  employee_id: Yup.string().when('employees', {
    is: val => !val,
    then: Yup.string().required('Debes seleccionar un trabajador'),
    otherwise: Yup.string()
  })
});

const setInitialValues = () => {
  return {
    employee_id: '',
    employees: null
  };
};

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  try {
    const res = formRequest(values, setSubmitting);
    if (res && typeof res.then === 'function') {
      return res.finally(() => setSubmitting(false));
    }
    setSubmitting(false);
    return null;
  } catch (err) {
    setSubmitting(false);
    throw err;
  }
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: false
})(VacationBalance);
